import { convertValueToLocale } from "helpers/convertValueToLocale";

export const getAdjustedValue = (value: number | null, cellType: string) => {
  if (value === null) {
    return "";
  }

  if (cellType === "currency") {
    return convertValueToLocale(value);
  }

  if (cellType === "boolean") {
    return value ? "Ja" : "Nein";
  }

  if (cellType === "percentage") {
    return convertValueToLocale(value, 2, "%");
  }

  return value;
};
